/*
 * @Description 组件 LicenseDropDown 授头部权
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<el-dropdown type="primary" trigger="click" @command="handleCommand">
		<span class="el-dropdown-link">
			<span class="iconfont el-icon-my_xiazai3 cursor-pointer" style="font-size: 26px;padding-top: 20px;" title="资源下载" />
		</span>
        <el-dropdown-menu slot="dropdown" style="text-align: left;">
			<!-- icon是修改图标 ，command是点击后传给方法的值-->
			<el-dropdown-item v-for="(item, index) in dataList" :key="index" :icon="item.icon" :command="item.command">&ensp;&ensp;{{item.text}}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable';
	// 公用函数
	import GlobalFun from '@/global/global-function';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "FilesDownload",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// data list
				dataList: [
					{icon: 'el-icon-download', text: 'NFC读卡程序', command: 'NFC_ID_Setup'},
					{icon: 'el-icon-download', text: '身份证读卡程序', command: 'ZKIDROnline'},
					{icon: 'el-icon-download', text: 'VLC 视频播放器', command: 'VLCPlayer'},
					{icon: 'el-icon-download', text: '平台使用说明书', command: 'Tutorial'},
				],// dataList
				// files 资源
				files: {
					// NFC读卡程序
					NFC_ID_Setup: {fileName: 'NFC_ID_Setup.zip', fileUrl: '/static/software/NFC_ID_Setup.zip'},
					// 身份证读卡程序
					ZKIDROnline: {fileName: 'ZKIDROnline.exe', fileUrl: '/static/software/ZKIDROnline.exe'},
					// VLC 视频播放器
					VLCPlayer: {fileName: 'vlc-3.0.17.4-win64.exe', fileUrl: '/static/software/vlc-3.0.17.4-win64.exe'},
					// 平台使用说明书
					Tutorial: {fileName: '金坤科创GNSS云平台系统使用说明书-v1.1.pdf', fileUrl: '/static/docs/Tutorial-TunnelSystem-v1.1.pdf'},
				},// files
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 点击下载
			 * @Auth
			 * @Date
			 */
			handleCommand(command) {
				let row = Object.assign({}, this.files[command]);
				// 文件名
                let fileName = row.fileName;
                // 资源文件下载 至本地
                GlobalFun.downloadFile((GlobalVariable.PAGE_PATH + row.fileUrl), fileName);
			},// handleCommand
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/FilesDownload/FilesDownload.vue